/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PageFanResponseProjection } from '../models/PageFanResponseProjection';
import type { PageRecentSpenderListProjection } from '../models/PageRecentSpenderListProjection';
import type { RecentSpenderListForm } from '../models/RecentSpenderListForm';
import type { RecentSpenderListProjection } from '../models/RecentSpenderListProjection';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardRecentSpenderListRestEndpointService {
    /**
     * @returns RecentSpenderListProjection OK
     * @throws ApiError
     */
    public static dashboardGetRecentSpenderList({
        creatorId,
        listId,
    }: {
        creatorId: number,
        listId: number,
    }): CancelablePromise<RecentSpenderListProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/recent-spender-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static dashboardUpdateRecentSpenderList({
        creatorId,
        listId,
        requestBody,
    }: {
        creatorId: number,
        listId: number,
        requestBody: RecentSpenderListForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/list-feature/recent-spender-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static dashboardDeleteRecentSpenderList({
        creatorId,
        listId,
    }: {
        creatorId: number,
        listId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/list-feature/recent-spender-list/creator/{creatorId}/list/{listId}',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
        });
    }
    /**
     * @returns PageRecentSpenderListProjection OK
     * @throws ApiError
     */
    public static dashboardGetRecentSpenderLists({
        creatorId,
        name,
        page,
        size = 20,
    }: {
        creatorId: number,
        name?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<PageRecentSpenderListProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/recent-spender-list/creator/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'name': name,
                'page': page,
                'size': size,
            },
        });
    }
    /**
     * @returns RecentSpenderListProjection OK
     * @throws ApiError
     */
    public static dashboardCreateRecentSpenderList({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: RecentSpenderListForm,
    }): CancelablePromise<RecentSpenderListProjection> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/list-feature/recent-spender-list/creator/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PageFanResponseProjection OK
     * @throws ApiError
     */
    public static dashboardGetRecentSpenderListFans({
        creatorId,
        listId,
        fanName,
        page,
        size = 20,
    }: {
        creatorId: number,
        listId: number,
        fanName?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<PageFanResponseProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/recent-spender-list/creator/{creatorId}/list/{listId}/fans',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
            query: {
                'fanName': fanName,
                'page': page,
                'size': size,
            },
        });
    }
}
